module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Stop-3e6b6fb2e9450136e6a8af4cabfe0397.svg";